import React from 'react';
import PercentageBar from '@components/progress/breakdown/micro/PercentageBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGauge } from '@fortawesome/free-solid-svg-icons/faGauge';
import { faGaugeHigh } from '@fortawesome/free-solid-svg-icons/faGaugeHigh';
import { faGaugeMin } from '@fortawesome/pro-solid-svg-icons/faGaugeMin';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface PercentageByDifficultyProps {
  difficulty: 'Easy' | 'Medium' | 'Hard';
  percentage: number;
  attempt: number;
  className?: string;
}

const PercentageByDifficulty = (props: PercentageByDifficultyProps) => {
  const percentageIcon = (difficulty: 'Easy' | 'Medium' | 'Hard') => {
    switch (difficulty) {
      case 'Easy':
        return (
          <FontAwesomeIcon
            icon={faGaugeMin as IconProp}
            className={'text-[#A0E274]'}
            data-testid={'easy-icon'}
          />
        );
      case 'Medium':
        return (
          <FontAwesomeIcon
            icon={faGauge}
            className={'text-[#FED00B]'}
            data-testid={'medium-icon'}
          />
        );
      case 'Hard':
        return (
          <FontAwesomeIcon
            icon={faGaugeHigh}
            className={'text-[#F56468]'}
            data-testid={'hard-icon'}
          />
        );
    }
  };

  return (
    <div
      className={
        'w-full rounded-2xl p-1 text-neutral-chalk text-sm mt-[10px] leading-[1.2] ' +
        props.className
      }
    >
      <div className={'flex mb-2 w-full items-center'}>
        <div className={'mr-1 w-[14px] h-[14px]'}>
          {percentageIcon(props.difficulty)}
        </div>
        <div className={'font-bold text-xs from-neutral-sketchbook'}>
          {props.difficulty}
        </div>
        <div className={'ml-auto text-xs font-normal text-neutral-periwinkle'}>
          {props.attempt + ' ' + (props.attempt > 1 ? 'questions' : 'question')}
        </div>
      </div>
      <PercentageBar percentage={props.percentage} attempt={props.attempt} />
    </div>
  );
};

export default PercentageByDifficulty;
